import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyArlU-RzfuJqP15oraQix-JhI4mQ3aocg0",
  authDomain: "ooloz-74908.firebaseapp.com",
  projectId: "ooloz-74908",
  storageBucket: "ooloz-74908.firebasestorage.app",
  messagingSenderId: "774095297878",
  appId: "1:774095297878:web:e2db4535f6c7088ea9caf7"
};

const app = initializeApp(firebaseConfig);

if (typeof window !== "undefined") {
  // We use window specifically and disable the linter for this one line
  // eslint-disable-next-line no-undef
window.FIREBASE_APPCHECK_DEBUG_TOKEN = "84726E81-1546-4A86-936D-712B1C7F874A";
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6Lfh5oMsAAAAADfD6xYBSgVlfAAUN_Kuazv8sAUF'),
    isTokenAutoRefreshEnabled: true 
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);